export const ACTION_HEADER_KEY = 'x-action-id';

export const ACTIONS_IDS = {
	pointsOfSale: {
		create: 'points-of-sale.create',
		delete: 'points-of-sale.delete',
		sendVirtualCredit: 'points-of-sale.send-virtual-credit',
		update: 'points-of-sale.update',
		evaDts: {
			create: 'points-of-sale.eva-dts.create',
			download: 'points-of-sale.eva-dts.download',
		},
		connectivity: {
			restart: 'points-of-sale.connectivity.restart',
			reset: 'points-of-sale.connectivity.reset',
			updateVersion: 'points-of-sale.connectivity.update-version',
		},
		irp: {
			createConfiguration: 'points-of-sale.irp.create-configuration',
			updateConfiguration: 'points-of-sale.irp.update-configuration',
			deleteConfiguration: 'points-of-sale.irp.delete-configuration',
		},
		activity: {
			refund: 'points-of-sale.activity.refund',
		},
		planogram: {
			update: 'points-of-sale.planogram.update',
			createCatalogue: 'points-of-sale.planogram.create-catalogue',
		},
		masterConfig: {
			update: 'points-of-sale.master-config.update',
		},
		inhibitSchedule: {
			update: 'points-of-sale.inhibit-schedule.update',
		},
		favoriteMachines: {
			add: 'points-of-sale.favorite-machines.add',
		},
	},
	posPersonalization: {
		create: 'pos-personalization.create',
		update: 'pos-personalization.update',
		delete: 'pos-personalization.delete',
		saveDraft: 'pos-personalization.saveDraft',
		activate: 'pos-personalization.activate',
		deactivate: 'pos-personalization.deactivate',
		sendToValidate: 'pos-personalization.sendToValidate',
	},
	posAds: {
		update: 'pos-ads.update',
		reset: 'pos-ads.reset',
	},
	products: {
		create: 'product.create',
		delete: 'product.delete',
		update: 'product.update',
	},
	endUsers: {
		users: {
			sendVirtualCredit: 'user.send-virtual-credit',
		},
		nfcTags: {
			create: 'nfc-tag.create',
			sendVirtualCredit: 'nfc-tag.send-virtual-credit',
			block: 'nfc-tag.block',
			unblock: 'nfc-tag.unblock',
			delete: 'nfc-tag.delete',
			rename: 'nfc-tag.rename',
			whiteList: {
				add: 'nfc-tag.white-list.add',
				delete: 'nfc-tag.white-list.delete',
			},
		},
		qrs: {
			create: 'qr.create',
			delete: 'qr.delete',
			whiteList: {
				add: 'qr.white-list.add',
				delete: 'qr.white-list.delete',
			},
		},

		userSupport: {
			reopen: 'user-support.reopen',
			close: 'user-support.close',
			refund: 'user-support.refund',
			refuseRefund: 'user-support.refuse-refund',
			sendVirtualCredit: 'user-support.send-virtual-credit',
		},
	},
	benefits: {
		promotion: {
			create: 'promotion.create',
			delete: 'promotion.delete',
			update: 'promotion.update',
			pause: 'promotion.pause',
			activate: 'promotion.activate',
		},
		packs: {
			// Api still calls it bundle.
			create: 'bundle.create',
			delete: 'bundle.delete',
			update: 'bundle.update',
			pause: 'bundle.pause',
			activate: 'bundle.activate',
		},
	},

	reconciliations: {
		download: 'reconciliations.download',
	},

	reports: {
		download: 'reports.download',
		create: 'reports.create',
		delete: 'reports.delete',
		templates: {
			create: 'report.template.create',
			delete: 'report.template.delete',
			update: 'report.template.update',
			rename: 'report.template.rename',
			duplicate: 'report.template.duplicate',
			runReport: 'report.template.run',
		},
	},

	alerts: {
		configuration: {
			create: 'alerts.configuration.create',
			update: 'alerts.configuration.update',
			delete: 'alerts.configuration.delete',
			pause: 'alerts.configuration.pause',
			activate: 'alerts.configuration.activate',
		},
	},

	roles: {
		create: 'role.create',
		update: 'role.update',
		delete: 'role.delete',
		resendActivationEmail: 'role.resend_activation_email',
		resetPassword: 'role.reset_password',
		createCustom: 'role.create_custom',
		deleteCustom: 'role.delete_custom',
		updateCustom: 'role.update_custom',
	},

	technicians: {
		create: 'technician.create',
		delete: 'technician.delete',
	},

	delegations: {
		create: 'delegation.create',
		update: 'delegation.update',
		delete: 'delegation.delete',
	},

	company: {
		updateFiscalData: 'company.update-fiscal-data',
		updateReimboursement: 'company.update-reimboursement',
		updateCurrency: 'company.update-currency',
		updateErp: 'company.update-erp',
	},

	orain: {
		redirect: 'redirect',
	},

	marketplace: {
		addonsOpportunity: 'addons:opportunity',
		devicesInterest: 'devices:interest',
	},

	interest: {
		reconciliation: 'interest.reconciliation',
		alerts: 'interest.alerts',
		scheduledReports: 'interest.scheduled-reports',
	},

	banners: {
		homeBanners: (bannerId: number) => `home-banner.${bannerId}`,
	},
} as const;
